//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Rule.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["ruleInstance","filename"],"SaveRule",{},2,0],[["path"],"OpenRuleInPart",{R_:{ruleInstance:"Rule.RuleInstance"}},1,0],[["path"],"InstantiateRule",{R_:{ruleInstance:"Rule.RuleInstance"}},1,0],[["part","applicaton","ruleName"],"CreateRule",{R_:{ruleInstance:"Rule.RuleInstance"}},3,0],[["rules"],"ExecuteRules",{},1,0],[["parentRuleInstance","childRuleInstance"],"AddRelation",{},2,0],[["ruleInstance"],"RemoveRelation",{},1,0],[["ruleInstance"],"CreateRuleSaveAsBuilder",{R_:{builder:"Rule.RuleSaveAsBuilder"}},1,0],[["part"],"CreateRuleOpenBuilder",{R_:{builder:"Rule.RuleOpenBuilder"}},1,0],[["part","applicaton","ruleName"],"CreateSnippet",{R_:{snippet:"Rule.Snippet"}},3,0],[["ruleInstance"],"CreateRuleSaveBuilder",{R_:{builder:"Rule.RuleSaveBuilder"}},1,0]],[["RuleInstanceCollection","Rule.RuleInstanceCollection",0],["SnippetCollection","Rule.SnippetCollection",0]]];
SPLM.Rule.RuleManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Rule.RuleManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;